import { e5 as e5apis, MediaCloudPublishCenterCreate as create } from '@apis'
import Vue from 'vue'
import { handleTableFormat } from '../common'
import { createAPI, options } from '../../common'
import ComE5PictureTable from '../components/table/components/PictureTable'
import StorageEnum from 'common-mediax/src/common/Enum/StorageEnum'
const e5 = {
  namespaced: true,
  state: function () {
    return {
      conditions: {},
      lists: [],
      listData: {},
      tableFormat: [],
      tableSortData: [],
      tableListData: {},
      tableType: {},
      partFields: {},
      showTableType: '', // localstorage存储表格类型
      showTableId: '', // localstorage存储表格id
      form: {},
      actions: [], // 操作list
      detailActionsList: [], // 详情页操作
      actionsList: [],
      actionsTopList: [],
      actionTopUrls: [], // 需要放到actionsTopList里的url，如actionTopUrls为['articleAdd'],则所有包含articleAdd的操作都会放入actionsTopList
      actionParams: {},
      forms: [],
      censorshipTableData: {},
      issuesData: {},
      tableSelectedRows: [],
      tableOriginalData: {}, // 点击某一行的标题或图片时将该行信息保存（保存未处理的原始数据）
      tableSortColumn: {},
      tableComponents: {
        // table各类型列表组件
        ComE5PictureTable
      },
      tableComponentsList: {
        // table列表类型与组件的关联
        0: 'ComE5PictureTable'
      },
      currentPreaction: {}, // 当前预处理操作通过的ids和token
      paginationData: {
        currentPage: 1,
        pageSize: 20
      },
      ids: [],
      metadata: {
        // mediax服务新增两个固定字段docType，docLib
        docType: 32,
        /*文档库ID*/
        docLib: 33
        // mod: 'article-app',
        // docLib: 2, // 文档库ID
        // ch: 2 // 渠道，2表示App
      },
      fields: [],
      formData: [],
      formDataTmp: [], // 暂存检索从外部添加的默认参数
      adminOrgs: {},
      adminRoleData: {},
      orgTreeCurrentSelect: {},
      adminTreeNewKey: 0, // 机构树当前新建的节点
      cut: false,
      relatedArticles: [], // 相关稿件
      isNeedTableSet: false // e5列表是否可自定义，不可自定义的就不走自定义的接口了
    }
  },
  getters: {},
  mutations: {
    // 清空state
    cleanStateData(state) {
      Object.keys(state).forEach((key) => {
        if (key === 'paginationData') {
          state[key] = {
            currentPage: 1,
            pageSize: 20
          }
        } else if (key !== 'tableComponents' && key !== 'tableComponentsList') {
          if (Array.isArray(state[key])) {
            state[key] = []
          } else {
            switch (typeof state[key]) {
              case 'number':
                state[key] = 0
                break
              case 'object':
                state[key] = {}
                break
              case 'boolean':
                state[key] = false
                break
              case 'string':
                state[key] = ''
                break
            }
          }
        }
      })
    },
    cleanTableSelectedRows(state) {
      state.tableSelectedRows = []
    },
    UPDATE_META_DATA(state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          // 向metadata里保存column字段时清空数据，避免出现整个列表都显示“关联”图标
          if (item === 'column' && data[item] !== state.metadata.column) {
            state.listData = {}
            state.tableFormat = []
            state.tableSortData = []
          }
          Vue.set(state.metadata, item, data[item])
        })
      }
    },
    UPDATE_TABLE_TYPE(state, data) {
      state.tableType = JSON.parse(JSON.stringify(data.tableType)) // 存储当前table表头
      // 存储当前选择的table类型
      localStorage.setItem(data.e5namespace + 'showTableId', state.tableType.id)
      localStorage.setItem(
        data.e5namespace + 'showTableType',
        state.tableType.type
      )
      // 更新table类型时做处理，拿到格式化的table数据
      // state.tableFormat = handleTableFormat(state.tableType, state.listData)
      // state.tableFormat.forEach((item) => {
      //   item.row.forEach((line) => {
      //     line.fields.forEach((field) => {
      //       // 若展示字段是标题图（a_picSmall）或媒资库（mam_picUrl）的图片时的处理
      //       if ((field.code === 'a_picSmall' && field['a_picSmall']) ||
      //         (field.code === 'mam_picUrl' && field['mam_picUrl'])) {
      //         // 图片路径为‘图片存储;****’时，将图片转为base64
      //         if (field[field.code].indexOf('图片存储;') > -1) {
      //           e5apis.getE5Images({
      //             params: {
      //               path: field[field.code]
      //             }
      //           }).then(res => {
      //             Vue.set(field, 'topicTitleImg', res.data ? res.data : '')
      //           })
      //         }
      //       }
      //     })
      //   })
      // })
    },
    UPDATE_GET_E5_CONDITIONS(state, conditions) {
      state.conditions = conditions
    },
    /**
     * 主动更新检索条件，用于外部扩建添加默认的检索参数
     * params: [{
     *     code: '',
     *     value: '',
     *     value1: '', // 非必须， 检索条件类型是时间时需要
     *     isCustom: Boolean,为true表示该字段完全自定义，优先级最高
     * }]
     * @param state
     * @param params
     * @constructor
     */
    CUSTOM_UPDATE_FORM(state, params) {
      let tmp = JSON.parse(JSON.stringify(params))
      params.forEach((item, k) => {
        let count = false
        // value为空时去掉这个搜索项
        if (item.value === '') {
          count = true
          tmp.splice(k, 1)
        }
        for (let i in state.formData) {
          if (state.formData[i].code === item.code) {
            count = true
            item.value === ''
              ? state.formData.splice(i, 1)
              : (state.formData[i].value = item.value)
            item.value1 === ''
              ? state.formData.splice(i, 1)
              : (state.formData[i].value1 = item.value1)
          }
        }
        if (!count) {
          state.formData.push(item)
        }
      })
      state.formDataTmp = tmp
    },
    CUSTOM_UPDATE_SORTBY(state, params) {
      state.tableSortColumn.prop = params
    },
    UPDATE_FORM(state, payload) {
      state.formData = []
      let form = payload
      if (payload) {
        Object.keys(form).forEach((key) => {
          for (let k in state.conditions) {
            if (state.conditions[k].code === key) {
              if (
                state.conditions[k].type === 'DATETIME' ||
                state.conditions[k].type === 'DATAT' ||
                state.conditions[k].type === 'TIME'
              ) {
                if (
                  form[key] &&
                  typeof form[key] === 'object' &&
                  form[key].length === 2
                ) {
                  let param = {
                    code: key,
                    value: 0,
                    value1: 0
                  }
                  param.value = form[key][0]
                  param.value1 = form[key][1]
                  state.formData.push(param)
                }
                break
              } else {
                if (form[key]) {
                  state.formData.push({
                    code: key,
                    value: form[key]
                  })
                }
                // 若记录的查询条件中有该字段,并且该字段不是完全自定义的，但是该字段的查询value不存在，则在记录的list中去掉该字段
                let index = state.formDataTmp.findIndex(
                  (i) => i.code === key && !i.isCustom
                )
                if (index !== -1 && !form[key])
                  state.formDataTmp.splice(index, 1)
                break
              }
            }
          }
        })
      }
      if (state.formDataTmp.length > 0) {
        state.formDataTmp.forEach((item) => {
          let flag = state.formData.some((i) => {
            if (i.code === item.code) {
              // i.value = item.value
              return true
            }
          })
          if (!flag) {
            let obj = {
              code: item.code,
              value: item.value
            }
            // 检索类型是时间时，需要两个value
            if (item.value1) obj.value1 = item.value1
            // 自定义condition参数 （参考指令下达 op 参数）
            if (
              item.hasOwnProperty('customParams') &&
              typeof item.customParams === 'object'
            ) {
              obj = {
                ...obj,
                ...item.customParams
              }
            }
            state.formData.push(obj)
          }
        })
      }
      // 更新listdata的查询条件formdata之后需要更新检索组件的绑定对象form，防止自定义检索条件检索条件显示不正确
      Object.keys(state.form).forEach((key) => {
        for (let i in state.formData) {
          if (
            state.formData[i].code === key &&
            state.formData[i].value &&
            !state.formData[i].value1
          )
            state.form[key] = state.formData[i].value
          if (
            state.formData[i].code === key &&
            state.formData[i].value &&
            state.formData[i].value1
          ) {
            state.form[key] = [
              state.formData[i].value,
              state.formData[i].value1
            ]
          }
        }
      })
    },
    UPDATE_FORM_KEYS(state, conditions) {
      if (Array.isArray(conditions)) {
        conditions.forEach((item) => {
          item.code && Vue.set(state.form, item.code, item.default || '')
        })
      }
    },
    UPDATE_GET_E5_LISTS(state, data) {
      let lists = data.lists
      let e5namespace = data.e5namespace
      let exist = false
      if (Array.isArray(lists)) {
        state.lists = lists
        state.tableSortColumn.prop = lists[0].sortby // 初始化排序字段
        state.tableSortColumn.order = lists[0].sorttype // 初始化排序方式
        state.paginationData.pageSize = lists[0].rows[0] // 初始pageSize
        state.paginationData.currentPage = 1

        // 默认显示localstorage中存储的table
        let showTableType =
          localStorage.getItem(e5namespace + 'showTableType') + ''
        let showTableId = localStorage.getItem(e5namespace + 'showTableId') + ''
        if (showTableType && state.lists) {
          for (let k in state.lists) {
            // 若localstorage存储的列表在lists中存在，设置table类型
            if (
              showTableType === state.lists[k].type + '' &&
              showTableId === state.lists[k].id + ''
            ) {
              state.tableType = JSON.parse(JSON.stringify(state.lists[k]))
              state.paginationData.pageSize = state.tableType.rows[0] // pageSize
              exist = true
              break
            }
          }
        }
        // 若本地存储中没有对应的列表，则默认设置tableType为返回的第一个表头
        if (!exist) {
          state.tableType = JSON.parse(JSON.stringify(state.lists[0]))
        }
      }
    },
    UPDATE_POST_E5_LIST_DATA(state, data) {
      state.listData = data.data
    },
    updateActionTopUrls(state, array) {
      if (Array.isArray(array)) state.actionTopUrls = array
    },
    UPDATE_GET_E5_ACTIONS(state, data) {
      state.actionsList = []
      state.actionsTopList = []
      state.actions = data.actions
      if (
        state.actions &&
        state.actions.length > 0 &&
        Array.isArray(state.actionTopUrls) &&
        state.actionTopUrls.length > 0
      ) {
        state.actions.forEach((action) => {
          let index = state.actionTopUrls.findIndex(
            (url) => action.url.indexOf(url) > -1
          )
          index > -1
            ? state.actionsTopList.push(action)
            : state.actionsList.push(action)
        })
      } else {
        state.actionsList = state.actions
      }
    },
    UPDATE_GET_E5_DETAIL_ACTIONS(state, data) {
      state.detailActionsList = data.listactions
    },
    UPDATE_GET_E5_FORMS(state, forms) {
      state.forms = forms
    },
    UPDATE_ISSUES_DATA(state, data) {
      state.issuesData = data
    },
    UPDATE_TABLE_SELECTED_ROWS(state, data) {
      state.tableSelectedRows = data
      state.ids = []
      data.forEach((item) => {
        state.ids.push(item.id)
      })
    },
    UPDATE_TABLE_SORT_COLUMN(state, data) {
      switch (data.order) {
        case 'descending':
          data.order = 1
          break
        case 'ascending':
          data.order = 0
          break
        default:
          data.order = 0
      }
      state.tableSortColumn = data
    },
    UPDATE_E5_PREACTION(state, data) {
      state.currentPreaction = data
    },
    UPDATE_PAGINATION_DATA(state, data) {
      state.paginationData.currentPage =
        data.currentPage || state.paginationData.currentPage
      state.paginationData.pageSize =
        data.pageSize || state.paginationData.pageSize
    },
    UPDATE_FIELDS(state, data) {
      state.fields = data
      state.partFields = JSON.parse(JSON.stringify(state.tableType))
      if (data.length !== 0) {
        let showFields = []
        data.forEach((v) => {
          state.tableType.lines.forEach((val) => {
            if (v === val.code) {
              showFields.push(val)
            }
          })
        })
        state.partFields.lines = showFields
      }
      // debugger
      state.tableFormat = handleTableFormat(state.partFields, state.listData)
      state.tableSortData = JSON.parse(JSON.stringify(state.tableFormat))
      let newTableSelectedRows = [] // table数据更新后需要更新已选中的数据
      state.tableFormat.forEach((item) => {
        item.row.forEach((line) => {
          line.fields.forEach((field) => {
            // 若展示字段是标题图（a_picSmall）或媒资库（mam_picUrl）的图片时的处理
            if (
              (field.code === 'a_picSmall' && field['a_picSmall']) ||
              (field.code === 'mam_picUrl' && field['mam_picUrl'])
            ) {
              // 图片路径为‘-block;****’时，将图片转为base64
              if (!/^http/.test(field[field.code])) {
                // 媒资库由于是上传图片的地方，小图可能会不存在，所以要取base64的用于判断小图是否存在
                create
                  .getE5ImagesNoLoading({
                    params: {
                      path: field[field.code]
                    }
                  })
                  .then((res) => {
                    Vue.set(
                      field,
                      'topicTitleImg',
                      res.data ? 'data:image/*;base64,' + res.data : ''
                    )
                  })
              }
            }
            if (field.code === 'a_attachments' && field['a_attachments']) {
              let attachment = JSON.parse(field['a_attachments'])
              Vue.set(field, 'JSON_a_attachments', attachment)
              if (Array.isArray(attachment)) {
                if (
                  attachment.length > 0 &&
                  typeof attachment[0] === 'string' &&
                  attachment[0].indexOf('http') === -1 &&
                  attachment[0].indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                ) {
                  let url = options.options.getFileUrl({
                    url: '/e5/imagefile',
                    params: { path: attachment[0] }
                  })
                  Vue.set(field, 'attachment', url)
                }
              } else if (typeof attachment === 'object') {
                Object.keys(attachment).forEach((k) => {
                  if (
                    attachment[k].length > 0 &&
                    typeof attachment[k][0] === 'string' &&
                    attachment[k][0].indexOf('http') === -1 &&
                    attachment[k][0].indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                  ) {
                    let url = options.options.getFileUrl({
                      url: '/e5/imagefile',
                      params: { path: attachment[k][0] }
                    })
                    Vue.set(field, 'attachment_' + k, url)
                  }
                  if (
                    attachment[k].length > 0 &&
                    k === 'pics' &&
                    typeof attachment[k][0] === 'string'
                  ) {
                    // 爆料那块的，attachment的格式是{pics:[''],videos:[url:'']}
                    attachment[k].forEach((item, index) => {
                      let url = options.options.getFileUrl({
                        url: '/e5/imagefile',
                        params: { path: item }
                      })
                      Vue.set(field, 'attachment_new_' + k + index, url)
                    })
                  }
                  if (attachment[k].length > 0 && attachment[k][0].path) {
                    // 直播控制台那块的图片
                    for (let i = 0; i < attachment[k].length; i++) {
                      let path = attachment[k][i].path
                      if (
                        typeof path === 'string' &&
                        path.indexOf('http') === -1 &&
                        path.indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                      ) {
                        let url = options.options.getFileUrl({
                          url: '/e5/imagefile',
                          params: { path: attachment[k][i].path }
                        })
                        Vue.set(field, 'attachment_new_' + k + i, url)
                      }
                    }
                  }
                })
              }
            }
            if (
              field.code === 'entry_attachments' &&
              field['entry_attachments']
            ) {
              let attachment = JSON.parse(field['entry_attachments'])
              Vue.set(field, 'JSON_entry_attachments', attachment)
              if (Array.isArray(attachment)) {
                if (
                  attachment.length > 0 &&
                  typeof attachment[0] === 'string' &&
                  attachment[0].indexOf('http') === -1 &&
                  attachment[0].indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                ) {
                  let url = options.options.getFileUrl({
                    url: '/e5/imagefile',
                    params: { path: attachment[0] }
                  })
                  Vue.set(field, 'attachment', url)
                }
              } else if (typeof attachment === 'object') {
                Object.keys(attachment).forEach((k) => {
                  if (
                    attachment[k].length > 0 &&
                    typeof attachment[k][0] === 'string' &&
                    attachment[k][0].indexOf('http') === -1 &&
                    attachment[k][0].indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                  ) {
                    let url = options.options.getFileUrl({
                      url: '/e5/imagefile',
                      params: { path: attachment[k][0] }
                    })
                    Vue.set(field, 'attachment_' + k, url)
                  }
                  if (
                    attachment[k].length > 0 &&
                    k === 'pics' &&
                    typeof attachment[k][0] === 'string'
                  ) {
                    // 爆料那块的，attachment的格式是{pics:[''],videos:[url:'']}
                    attachment[k].forEach((item, index) => {
                      let url = options.options.getFileUrl({
                        url: '/e5/imagefile',
                        params: { path: item }
                      })
                      Vue.set(field, 'attachment_new_' + k + index, url)
                    })
                  }
                  if (attachment[k].length > 0 && attachment[k][0].path) {
                    // 直播控制台那块的图片
                    for (let i = 0; i < attachment[k].length; i++) {
                      let path = attachment[k][i].path
                      if (
                        typeof path === 'string' &&
                        path.indexOf('http') === -1 &&
                        path.indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                      ) {
                        let url = options.options.getFileUrl({
                          url: '/e5/imagefile',
                          params: { path: attachment[k][i].path }
                        })
                        Vue.set(field, 'attachment_new_' + k + i, url)
                      }
                    }
                  }
                })
              }
            }
            if (field.code === 'wxg_members' && field['wxg_members']) {
              let wxgMembers = JSON.parse(field['wxg_members'])
              Vue.set(field, 'JSON_wxg_members', wxgMembers)
              if (Array.isArray(wxgMembers)) {
                wxgMembers.forEach((item) => {
                  if (item.picBig.indexOf(StorageEnum.STORAGE_SUFFIX) > -1) {
                    let picBigUrl = options.options.getFileUrl({
                      url: '/e5/imagefile',
                      params: { path: item.picBig }
                    })
                    Vue.set(item, 'picBigData', picBigUrl)

                    if (
                      item.picSmall.indexOf(StorageEnum.STORAGE_SUFFIX) > -1
                    ) {
                      let url = options.options.getFileUrl({
                        url: '/e5/imagefile',
                        params: { path: item.picSmall }
                      })
                      Vue.set(item, 'picSmallData', url)
                    }
                  }
                })
              }
            }
            // 若展示字段是人物头像（l_icon）（政情）
            if (field.code === 'l_icon') {
              // 图片路径为‘-block;****’时，将图片转为base64
              if (!/^http/.test(field[field.code])) {
                create
                  .getE5ImagesNoLoading({
                    params: {
                      path: field[field.code]
                    }
                  })
                  .then((res) => {
                    Vue.set(
                      field,
                      'lIconImg',
                      res.data ? 'data:image/*;base64,' + res.data : ''
                    )
                  })
              }
            }
          })
        })
        if (state.tableSelectedRows.length) {
          state.tableSelectedRows.forEach((row) => {
            if (row.id === item.id) {
              newTableSelectedRows.push(item)
            }
          })
        }
      })
      state.tableSelectedRows = newTableSelectedRows
    },
    updateTableSortData(state, list) {
      state.tableFormat = JSON.parse(JSON.stringify(list))
    },
    updateTableSetFlag(state, isNeed) {
      state.isNeedTableSet = isNeed
    },
    UPDATE_GET_E5_ADMIN_ORGS_LIST(state, params) {
      state.adminOrgs = params
    },
    UPDATE_ADMIN_ROLE_DATE(state, params) {
      state.adminRoleData = params
    },
    UPDATE_ORG_TREE_CURRENT_SELECT(state, params) {
      state.orgTreeCurrentSelect = params
    },
    UPDATE_CUT_DATA(state, data) {
      state.cut = data
    },
    UPDATE_RELATED_ARTICLES(state, data) {
      state.relatedArticles = data
    },
    FETCH_RELATED_ARTICLES(state) {
      return state.relatedArticles
    },
    /**
     * 修改table数据某几项，暂时只支持修改showtype=0直接显示和showtype=1判断显示的数据
     * @param params Array
     *  [{
     *      id: '2,111',
     *      actions: [], // 本行的操作
     *      data: [{
     *          code: 'a_status',
     *          value: 3,
     *          text: 'text'
     *      }]
     *  }]
     */
    updateTableFormat(state, params) {
      if (Array.isArray(params) && params.length > 0) {
        params.forEach((item) => {
          let row = state.tableFormat.find((row) => row.id === item.id)
          if (item.data.length > 0) {
            item.data.forEach((ite) => {
              Vue.set(row.rowOriginal, ite.code, ite.value)
              let innerRow = row.row.find((inner) => ite.code === inner.code)
              let field = innerRow.fields.find(
                (field) => field.code === ite.code
              )
              if (field.showtype === 0) Vue.set(field, ite.code, ite.value)
              if (field.showtype === 1) {
                Vue.set(field.options[0], 'value', ite.value)
                Vue.set(field.options[0], 'text', ite.text)
              }
            })
            // 修改改行的操作显示
            Vue.set(row.rowOriginal, 'actions', item.actions)
          }
        })
      }
    }
  },
  actions: {
    updateTableFormat({ commit }, params) {
      commit('updateTableFormat', params || [])
    },
    cleanStateData({ commit }) {
      commit('cleanStateData')
    },
    cleanTableSelectedRows({ commit }) {
      commit('cleanTableSelectedRows')
    },
    updateTableSortData({ commit }, list) {
      commit('updateTableSortData', list)
    },
    updateTableSetFlag({ commit }, isNeed) {
      commit('updateTableSetFlag', isNeed)
    },
    FETCH_META_DATA({ commit }, params) {
      commit('UPDATE_META_DATA', params)
    },
    DEL_META_DATA_PROPERTY({ commit, state }, key) {
      if (typeof state.metadata === 'object') {
        delete state.metadata[key]
      }
    },
    DEL_META_DATA({ commit, state }, params) {
      delete state[params]
    },
    FETCH_TABLE_TYPE({ commit, dispatch }, data) {
      commit('UPDATE_TABLE_TYPE', {
        tableType: data.tableType,
        e5namespace: data.e5namespace
      })
      // dispatch('FETCH_GET_E5_LIST_DEFINITION')
    },
    FETCH_GET_E5_CONDITIONS({ commit, state }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      let mixinConfig = mixinAndStringifyForGet(state, config)
      return e5apis.getE5Conditions(mixinConfig, vconfig).then((res) => {
        if (
          res.data.status === 0 &&
          res.data.data &&
          res.data.data.conditions
        ) {
          commit('UPDATE_GET_E5_CONDITIONS', res.data.data.conditions)
          commit('UPDATE_FORM_KEYS', res.data.data.conditions)
          commit('UPDATE_FORM', res.data.data.conditions)
        }
        return res.data.data
      })
    },
    FETCH_GET_E5_LISTS({ commit, state, dispatch }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      let mixinConfig = mixinAndStringifyForGet(state, config)
      return e5apis.getE5Lists(mixinConfig, vconfig).then((res) => {
        if (res.data.data) {
          commit('UPDATE_GET_E5_LISTS', {
            lists: res.data.data.lists,
            e5namespace: vconfig && vconfig.e5namespace
          })
          /* dispatch('FETCH_GET_E5_LIST_DEFINITION') */
        }
        return res.data.data
      })
    },
    FETCH_POST_E5_LIST_DATA({ commit, state, dispatch }, params) {
      console.log('调用e5 action')
      let config = params && params.config
      let vconfig = params && params.vconfig
      let mixinConfig = mixinAndStringifyForPost(state, config)
      return e5apis.postE5ListData(mixinConfig, vconfig).then((res) => {
        if (res.data.data) {
          commit('UPDATE_POST_E5_LIST_DATA', {
            data: res.data.data,
            e5namespace: vconfig.e5namespace
          })
          commit('UPDATE_TABLE_TYPE', {
            tableType: state.tableType,
            e5namespace: vconfig.e5namespace
          })
          dispatch('FETCH_GET_E5_LIST_DEFINITION')
        }
        return res.data.data
      })
    },
    FETCH_GET_E5_ACTIONS({ state, commit }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      let mixinConfig = mixinAndStringifyForGet(state, config)
      return e5apis.getE5Actions(mixinConfig, vconfig).then((res) => {
        if (res.data.data) {
          commit('UPDATE_GET_E5_ACTIONS', res.data.data)
        }
        return res.data.data
      })
    },
    updateActionTopUrls({ commit }, params) {
      if (Array.isArray(params)) commit('updateActionTopUrls', params)
    },
    customActions({ commit }, params) {
      if (params && params.actions && params.actions.length > 0) {
        commit('UPDATE_GET_E5_ACTIONS', params)
      } else {
        commit('UPDATE_GET_E5_ACTIONS', { actions: [] })
      }
    },
    FETCH_GET_E5_DETAIL_ACTIONS({ state, commit }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      // let mixinConfig = mixinAndStringifyForGet(state, config)
      return e5apis.getE5DetailActions(config, vconfig).then((res) => {
        if (res.data.data) {
          commit('UPDATE_GET_E5_DETAIL_ACTIONS', res.data.data)
        }
        return res.data.data
      })
    },
    FETCH_GET_E5_FORMS({ commit }, params) {
      return e5apis.getE5Forms({ ...params }).then((res) => {
        if (res.data.data) {
          commit('UPDATE_GET_E5_FORMS', res.data.data.lines)
        }
        return res.data.data
      })
    },
    FETCH_E5_PREACTION({ state, commit }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      let mixinConfig = mixinAndStringifyForGet(state, config)
      return e5apis.getE5Preaction(mixinConfig, vconfig).then((res) => {
        if (res.data.data) {
          let preaction = {
            ...res.data.data,
            headers: {
              // 操作headers凭证  需要子组件调操作接口时放到request header中
              'base-param': JSON.stringify({
                ...state.metadata,
                ...res.data.data,
                action: config.params.params.action
              })
            },
            row: params.row
          }
          commit('UPDATE_E5_PREACTION', preaction)
          // commit('UPDATE_META_DATA', res.data.data) //操作相关 不存metadata
          // commit('UPDATE_META_DATA', { action: config.params.params.action }) //操作相关 不存metadata
        }
        return res.data
      })
    },
    FETCH_E5_POSTACTION({ state, commit }, params) {
      return e5apis.getE5Postaction(params.config, params.vconfig)
    },
    GO_FETCH({ state }, payload) {
      createAPI(payload, 'post', {})().then((res) => {
        console.info(res)
      })
    },
    FETCH_ISSUES_DATA({ state, commit }, params) {
      return e5apis.getIssuesData({ ...params }).then((res) => {
        if (res.data.data) {
          commit('UPDATE_ISSUES_DATA', res.data.data)
        }
        return res.data.data
      })
    },
    FETCH_TABLE_SELECTED_ROWS({ commit }, params) {
      commit('UPDATE_TABLE_SELECTED_ROWS', params)
    },
    FETCH_TABLE_SORT_COLUMN({ commit }, params) {
      commit('UPDATE_TABLE_SORT_COLUMN', params)
    },
    FETCH_PAGINATION_DATA({ commit }, params) {
      commit('UPDATE_PAGINATION_DATA', params)
    },
    FETCH_GET_E5_LIST_DEFINITION({ commit, state }, params) {
      if (!state.isNeedTableSet) {
        commit('UPDATE_FIELDS', [])
        return false
      }
      var config = {
        params: {
          id: state.tableType.id
        }
      }
      var vconfig = params && params.vconfig ? params.vconfig : undefined
      return e5apis.getE5ListsDefinition(config, vconfig).then((res) => {
        if (res.data.status === 0) {
          if (
            res.data.data.lines.length !== 0 &&
            res.data.data.lines.length <= state.tableType.lines.length
          ) {
            commit('UPDATE_FIELDS', res.data.data.lines)
          } else {
            commit('UPDATE_FIELDS', [])
          }
        }
        return res.data.data
      })
    },
    FETCH_FORM({ commit }, params) {
      commit('UPDATE_FORM', params)
      commit('UPDATE_PAGINATION_DATA', { currentPage: 1 })
    },
    customUpdateForm({ commit }, params) {
      commit('CUSTOM_UPDATE_FORM', params)
      commit('UPDATE_PAGINATION_DATA', { currentPage: 1 })
    },
    customUpdateSortby({ commit }, params) {
      commit('CUSTOM_UPDATE_SORTBY', params)
      commit('UPDATE_PAGINATION_DATA', { currentPage: 1 })
    },
    FETCH_E5_FOLDER({ commit, state }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      return e5apis.getE5Folders(config, vconfig).then((res) => {
        if (res.data.status === 0) {
          state.tableSelectedRows = []
          state.ids = []
          return res.data.data
        }
      })
    },
    FETCH_E5_FOLDERBYDOCTYPE({ commit, state }, params) {
      let config = params && params.config
      let vconfig = params && params.vconfig
      return e5apis.getE5FoldersbBydocType(config, vconfig).then((res) => {
        if (res.data.status === 0) {
          state.tableSelectedRows = []
          state.ids = []
          return res.data.data
        }
      })
    },
    FETCH_E5_IMAGES({ commit }, params) {
      return e5apis.getE5Images({ ...params }).then((res) => {
        return res
      })
    },
    FETCH_E5_FILES({ commit }, params) {
      return e5apis.getE5Files({ ...params }).then((res) => {
        return res
      })
    },
    updateOriginalData({ state }, data) {
      state.tableOriginalData = data
    },
    FETCH_GET_E5_ADMIN_ORGS_LIST({ commit }, params) {
      return e5apis.getE5AdminOrgsList({ ...params }).then((res) => {
        if (res.data.status === 0) {
          commit('UPDATE_GET_E5_ADMIN_ORGS_LIST', res.data.data)
          return res.data.data
        }
      })
    },
    updateAdminRoleData({ commit }, params) {
      commit('UPDATE_ADMIN_ROLE_DATE', params)
    },
    updateOrgTreeCurrentSelect({ commit }, params) {
      commit('UPDATE_ORG_TREE_CURRENT_SELECT', params)
    },
    updateAdminTreeNewKey({ state }, val) {
      state.adminTreeNewKey = val
    },
    UPDATE_CUT_DATA({ commit }, params) {
      commit('UPDATE_CUT_DATA', params)
    },
    UPDATE_RELATED_ARTICLES({ commit }, params) {
      commit('UPDATE_RELATED_ARTICLES', params)
    },
    FETCH_RELATED_ARTICLES({ commit }) {
      commit('FETCH_RELATED_ARTICLES')
    }
  }
}

function mixinAndStringifyForGet(state, config) {
  let mixinConfig = {}
  if (config && config.hubConfig) {
    mixinConfig.hubConfig = config.hubConfig
  }
  if (config && config.params) {
    mixinConfig.params = {
      ...config.params
    }
    if (config.params.params) {
      mixinConfig.params.params = JSON.stringify({
        ...state.metadata,
        ...config.params.params
      })
    } else {
      mixinConfig.params.params = JSON.stringify(state.metadata)
    }
  } else {
    mixinConfig.params = {
      params: JSON.stringify(state.metadata)
    }
  }
  return mixinConfig
}

function mixinAndStringifyForPost(state, config) {
  let mixinConfig = {}
  if (config && config.data) {
    mixinConfig.data = {
      ...state.metadata,
      ...config.data
    }
    if (config.hubConfig) {
      mixinConfig.hubConfig = config.hubConfig
    }
  } else {
    mixinConfig.data = state.metadata
  }
  return mixinConfig
}

export default e5
